import {
  AccountPayableRecordFilterInput,
  AccountPayableRecordStatus,
  AccountsPayableRecordCategory,
} from 'generated/graphql'

export const allStatusesFilter: AccountPayableRecordFilterInput = {
  status: {
    in: [
      AccountPayableRecordStatus.UnderReview,
      AccountPayableRecordStatus.Flagged,
      AccountPayableRecordStatus.ScheduledPayment,
      AccountPayableRecordStatus.OpenQuery,
      AccountPayableRecordStatus.PaymentSent,
      AccountPayableRecordStatus.PaymentFailed,
      AccountPayableRecordStatus.Archived,
    ],
  },
}

export const awaitingApprovalStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.UnderReview,
  },
}

export const paymentSentStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.PaymentSent,
  },
}

export const approvedStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.Flagged,
  },
}

export const archivedStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.Archived,
  },
}

export const scheduledPaymentStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.ScheduledPayment,
  },
}

export const openQueriesStatusFilter: AccountPayableRecordFilterInput = {
  openQueries: {
    any: true,
  },
}

export const failedPaymentStatusFilter: AccountPayableRecordFilterInput = {
  status: {
    eq: AccountPayableRecordStatus.PaymentFailed,
  },
}

// Records marked as paid externally never get a batch, so they are left out
export const notBatchedFilter: AccountPayableRecordFilterInput = {
  bookingInvoiceBatchLineId: { eq: null },
  payedExternally: { eq: false },
  category: {
    in: [AccountsPayableRecordCategory.Telleroo, AccountsPayableRecordCategory.HedgeFlows],
  },
  status: {
    in: [
      AccountPayableRecordStatus.ScheduledPayment,
      AccountPayableRecordStatus.PaymentFailed,
      AccountPayableRecordStatus.Archived,
    ],
  },
}
